module.exports = __webpack_public_path__ + "img/manage-floor-plan.38484966.svg";